import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';
import { useTheme } from '../../contexts/ThemeContext';

const InteractionsChart = ({ data }) => {
  const { theme } = useTheme();

  const isDark = theme === 'dark';
  const gridColor = isDark ? 'rgba(255,255,255,0.04)' : '#f3f4f6';
  const textColor = isDark ? '#6b7280' : '#9ca3af';

  return (
    <>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id="interactionGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="resolvedGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10b981" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
          <XAxis
            dataKey="name"
            stroke={textColor}
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke={textColor}
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: isDark ? '#111' : '#fff',
              border: isDark ? '1px solid rgba(255,255,255,0.06)' : '1px solid #e5e7eb',
              borderRadius: '12px',
              color: isDark ? '#f9fafb' : '#111827',
            }}
          />
          <Area
            type="monotone"
            dataKey="interactions"
            stroke="#3b82f6"
            fillOpacity={1}
            fill="url(#interactionGradient)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="resolved"
            stroke="#10b981"
            fillOpacity={1}
            fill="url(#resolvedGradient)"
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
      <div className="flex justify-center space-x-6 mt-4">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
          <span className="text-sm text-gray-500 dark:text-gray-500">Total Interactions</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <span className="text-sm text-gray-500 dark:text-gray-500">Resolved</span>
        </div>
      </div>
    </>
  );
};

export default InteractionsChart;
